export default __webpack_public_path__ + "static/media/for-players.fe2aea17.png";